 let mutations = {
     CREATE_REBATE(state, rebate) {
         state.rebates.unshift(rebate)
             //state.currentRebate = rebate
             //return state.currentRebrebate
     },
     CREATE_CUSTOMER(state, customer) {
         state.customers.unshift(customer)
     },
     CREATE_MVPD_INFO(state, mvpdinfo) {
         state.mvpdinfo.unshift(mvpdinfo)
     },
     CHECK_REBATE(state, rebateData) {
         state.currentRebate = rebateData
     },
     GET_STATUSES(state, statuses) {
         return state.statuses = statuses
     },
     SHOW_ERRORS(state, errors) {
         return state.errors = errors
     },
     SET_SLIDERSTEP(state, step) {
         return state.sliderStep = step
     },
     SET_SHOWSLIDER(state, step) {
         return state.showSlider = !state.showSlider
     },
     SET_BILLSREQUIRED(state, val) {
         return state.billsRequired = val
     }
 }

 export default mutations